import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';


import { AppComponent } from './app.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatchRmComponent } from './match-rm/match-rm.component';
import { HelpSupportComponent } from './help-support/help-support.component';
import { BranchLocatorComponent } from './branch-locator/branch-locator.component';
import { OfficeListComponent } from './office-list/office-list.component';
import { CareerComponent } from './career/career.component';
import { HomeComponent } from './home/home.component';
import { CustomerReviewComponent } from './customer-review/customer-review.component';
import { CustomerReviewBannerComponent } from './customer-review-banner/customer-review-banner.component';
import { CustomerReviewLeadformComponent } from './customer-review-leadform/customer-review-leadform.component';
import { MediaMentionsComponent } from './media-mentions/media-mentions.component';
import { ProductServiceSearchComponent } from './product-service-search/product-service-search.component';
import { SmReviewsComponent } from './sm-reviews/sm-reviews.component';
import { AutoSuggestionSearchComponent } from './auto-suggestion-search/auto-suggestion-search.component';
import { AboutCeoComponent } from './about-ceo/about-ceo.component';
import { IdentityComponent } from './identity/identity.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LeaderComponent } from './leader/leader.component';
import { HistoricalNavComponent } from './historical-nav/historical-nav.component';
import { InvestmentBankingComponent } from './investment-banking/investment-banking.component';
import { OtherValuationsComponent } from './other-valuations/other-valuations.component';
import { IpoComponent } from './ipo/ipo.component';
import { TrackRecordComponent } from './track-record/track-record.component';



@NgModule({
  declarations: [
    AppComponent,
    AboutUsComponent,
    MatchRmComponent,
    HelpSupportComponent,
    BranchLocatorComponent,
    OfficeListComponent,
    CareerComponent,
    HomeComponent,
    CustomerReviewComponent,
    CustomerReviewBannerComponent,
    CustomerReviewLeadformComponent,
    MediaMentionsComponent,
    ProductServiceSearchComponent,
    SmReviewsComponent,
    AutoSuggestionSearchComponent,
    AboutCeoComponent,
    IdentityComponent,
    HeaderComponent,
    FooterComponent,
    LeaderComponent,
    HistoricalNavComponent,
    InvestmentBankingComponent,
    OtherValuationsComponent,
    IpoComponent,
    TrackRecordComponent ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SlickCarouselModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
